import type { AccountType } from '../../my-account/account-state';

/** SW 总部直营在表单中的占位 value；提交时会转为空串。 */
export const BELONGED_RESELLER_ADMIN_VALUE = 'Admin';

/**
 * 新增餐厅时经销商字段的表单默认值。
 * 经销商账号固定为自己的 id；其它账号默认为总部直营。
 * @param accountType 当前登录账号类型
 * @param resellerId 当前经销商账号 id（非经销商可省略）
 * @returns 表单 `belonged_reseller` 初始值
 */
export function getDefaultBelongedResellerForForm(
    accountType: AccountType | undefined,
    resellerId?: string,
): string {
    if (accountType === 'RESELLER' && resellerId) {
        return resellerId;
    }
    return BELONGED_RESELLER_ADMIN_VALUE;
}

/**
 * 保存餐厅时解析应提交的所属经销商 id。
 * 经销商账号必须提交自己的 id；Admin 占位转为空串表示总部直营。
 * @param accountType 当前登录账号类型
 * @param formValue 表单中的 belonged_reseller
 * @param resellerId 当前经销商账号 id
 * @returns 提交给后端的 belonged_reseller
 */
export function resolveBelongedResellerForPersist(
    accountType: AccountType | undefined,
    formValue: string | undefined,
    resellerId?: string,
): string {
    if (accountType === 'RESELLER') {
        return resellerId || '';
    }
    if (formValue === BELONGED_RESELLER_ADMIN_VALUE) {
        return '';
    }
    return formValue || '';
}

/**
 * 经销商下拉是否禁用：预览态或经销商账号不可改。
 * @param componentType 页面模式
 * @param accountType 当前登录账号类型
 * @returns 是否禁用输入
 */
export function isBelongedResellerInputDisabled(
    componentType: 'ADD' | 'EDIT' | 'PREVIEW' | 'BASE_INFO' | undefined,
    accountType: AccountType | undefined,
): boolean {
    return componentType === 'PREVIEW' || accountType === 'RESELLER';
}
